// @ts-nocheck
import clsx from 'clsx'
import {FC} from 'react'
import {Row, Column, ReadonlyArray} from 'react-table'
import {Task} from '../../core/_models'
import {useDropdownOpen} from '../../../../../../_metronic/context/DropdownOpenProvider'

type Props = {
  row: Row<Task>
  isSubtask?: boolean
  isParent?: boolean
  isExpanded?: boolean
  isLoading?: boolean
  onToggleExpand: (taskId: number) => void
  columns: ReadonlyArray<Column<Task>>
  level?: number
  disableStickyActions?: boolean
}

const CustomRow: FC<Props> = ({
  row,
  isSubtask = false,
  isParent = false,
  isExpanded = false,
  isLoading = false,
  onToggleExpand,
  columns,
  level = 0,
  disableStickyActions = false,
}) => {
  const task = row.original
  const {dropdownOpenTaskId} = useDropdownOpen()
  const isActionsDropdownOpen = task.id != null && dropdownOpenTaskId === Number(task.id)

  const handleToggleExpand = (e: React.MouseEvent) => {
    e.stopPropagation()
    e.preventDefault()
    if (task.id) {
      const taskId = typeof task.id === 'string' ? parseInt(task.id) : task.id
      onToggleExpand(taskId)
    }
  }

  return (
    <>
      <tr
        {...row.getRowProps()}
        className={clsx('bg-hover-light cursor-default', {
          'bg-light': isSubtask
        })}
      >
        {row.cells.map((cell, i) => {
          if (cell.column.id === 'dnd-handle') {
            return (
              <td
                {...cell.getCellProps()}
                key={i}
                style={{
                  position: 'relative',
                  width: '28px',
                  minWidth: '28px',
                  maxWidth: '28px',
                  paddingLeft: '0.5rem',
                  paddingRight: '0.25rem',
                  boxSizing: 'border-box'
                }}
              >
                <div
                  className="d-flex align-items-center"
                  style={{
                    gap: '8px',
                    marginLeft: level > 0 ? `${Math.min(level * 2.25, 5)}rem` : '0'
                  }}
                >
                  {level > 0 && !isParent && (
                    <span style={{width: '48px', display: 'inline-block'}}></span>
                  )}
                  {isParent && (
                    <button
                      type="button"
                      onClick={handleToggleExpand}
                      className="btn btn-sm btn-icon btn-light"
                      style={{
                        padding: '2px 4px',
                        minWidth: '20px',
                        width: '20px',
                        height: '20px',
                        flexShrink: 0
                      }}
                      title={isExpanded ? 'Colapsar subtarefas' : 'Expandir subtarefas'}
                    >
                      <i className={clsx('bi fs-6', {
                        'bi-chevron-down': isExpanded,
                        'bi-chevron-right': !isExpanded
                      })}></i>
                    </button>
                  )}
                </div>
              </td>
            )
          } else {
            return (
              <td
                {...cell.getCellProps()}
                className={clsx({
                  'text-end min-w-100px': cell.column.id === 'actions'
                })}
                style={(() => {
                  if (cell.column.id === 'actions') {
                    if (disableStickyActions) {
                      return undefined
                    }
                    return {
                      position: 'sticky',
                      right: 0,
                      backgroundColor: 'inherit',
                      zIndex: isActionsDropdownOpen ? 10 : 1
                    }
                  }
                  return level > 0 ? {
                    paddingLeft: `${Math.min(level * 2.25, 5)}rem`
                  } : undefined
                })()}
                key={i}
              >
                {cell.render('Cell')}
              </td>
            )
          }
        })}
      </tr>
      {isExpanded && isLoading && (
        <tr>
          <td 
            colSpan={columns.length} 
            className="text-center py-2"
            style={{paddingLeft: level > 0 ? `${Math.min(level * 2.25, 5)}rem` : undefined}}
          >
            <div className="spinner-border spinner-border-sm text-primary" role="status">
              <span className="visually-hidden">Carregando...</span>
            </div>
          </td>
        </tr>
      )}
    </>
  )
} 

export {CustomRow}
